import React from "react";
import { connect, ConnectedProps } from "react-redux";
import * as actions from "../../actionCreator";
import { GlobalApplicationState } from "globalApplicationState";

import Button from "@mui/material/Button";

import AddIcon from "@mui/icons-material/Add";


const NewCategoryTag: React.FunctionComponent<PropsWithRedux> = props => {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<AddIcon />}
      onClick={props.showNewCategoryTag}
    >
      New Category Tag
    </Button>
  );
}

interface ComponentProps {
}

const connector = connect(
  (state: GlobalApplicationState, ownProps: ComponentProps) => ({
    ...ownProps
  }),
  {
    showNewCategoryTag: actions.showNewCategoryTag
  }
);
type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(NewCategoryTag);